import moment from 'moment'

import { convertGregorianToJalali } from '../../helpers/date'
import { lang } from '../../localization'

/**
 * The comparison date, in the calendar the reader actually uses.
 *
 * Printing `YYYY-MM-DD` here rendered a Gregorian value to operators reading
 * Jalaali — and because the app calls `moment.locale('fa')` globally, in Persian
 * digits, so it LOOKED Jalaali while being roughly 621 years off. Every row on
 * this screen is keyed to a date, and an operator comparing our ۲۰۲۶-۰۸-۲۰ with
 * a PMS calendar showing ۱۴۰۵-۰۵-۲۹ is a misdiagnosis the screen caused.
 *
 * Shared by both breakpoints for the same reason LayerValue is: a value that
 * carries meaning must not be formatted twice.
 */
export function formatComparisonDate(date: string): string {
  if (lang === 'fa') {
    const jalaali = convertGregorianToJalali(moment(date).format('YYYY-MM-DD'))
    if (jalaali !== '') {
      return jalaali
    }
  }

  return moment(date).format('YYYY-MM-DD')
}

/**
 * A rate, in the app's digit system rather than the browser's.
 *
 * A bare toLocaleString() follows the BROWSER locale, so two operators opening
 * the same link could see the same price in different digit systems — on a
 * screen whose whole job is comparing three numbers side by side.
 */
export function formatRate(rate: number): string {
  return rate.toLocaleString(lang === 'fa' ? 'fa-IR' : 'en-US')
}
